<div class="container-fluid">
  <div class="content">
    <app-team-breadcrumb [s_breadcrumb]="'Attendance QR'"></app-team-breadcrumb>
    <div class="d-flex flex-wrap">
      <div class="mb-3">
        <button type="button" class="btn btn-custom" (click)="openSetupForm()">
          <i class="fa fa-plus me-1"></i>New Attendance QR
        </button>
      </div>
    </div>
    <ng-container>
      <div class="mb-2 d-flex flex-wrap justify-content-start align-items-center">

        <div class="input-group" style="width: 300px !important;" *ngIf="!isMobileView">
          <input class="form-control" type="text" placeholder="&#xf002; Search with Name/Location" aria-label="Search"
            (focus)="isFocus = true" (blur)="isFocus = false" [(ngModel)]="searchText"
            [ngClass]="{'c-search-input-with-clear' : searchText }" style="font-family: FontAwesome,Ubuntu;">
          <button class="btn btn-outline-secondary " type="button" *ngIf="searchText" (click)="clear()"
            [ngClass]="{'c-clear' : isFocus, 'c-clear-not-focus': !isFocus}">
            <mat-icon class="c-icon">close</mat-icon>
          </button>
        </div>
        <div class="dropdown" [ngClass]="{'ms-2' : !isMobileView, 'ms-0': isMobileView}">
          <button type="button" class="btn btn-custom" id="dropdownMenuButton1" data-bs-toggle="dropdown"
            aria-expanded="false" title="Page Size">
            <mat-icon>filter_list</mat-icon>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <div c style="text-align: center;">Page size</div>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li class="dropdown-item" *ngFor="let page of pg">
              <input type="radio" name="pg-count" value="{{page.count}}" (change)="changePageCount($event)"
                id="pg{{page.name}}" class="p-1" [checked]="page.count==100">
              <label for="pg{{page.name}}" class="col-10 p-1">
                {{page.name}}
              </label>
            </li>
          </ul>
        </div>
        <div class="ms-2">
          <button class="btn btn-custom" (click)="getAttendanceQrList()" title="Refresh">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <div class="line"></div>
        <div class="d-flex align-items-center">
          <span class="total-count-text">Total:&nbsp;</span> <span class="total-count-num">{{attQrList.length}}</span>
        </div>
      </div>
      <div class="input-group mb-2" *ngIf="isMobileView">
        <input class="form-control" type="text" placeholder="&#xf002; Search with Description/Type" aria-label="Search"
          (focus)="isFocus = true" (blur)="isFocus = false" [(ngModel)]="searchText"
          [ngClass]="{'c-search-input-with-clear' : searchText }" style="font-family: FontAwesome,Ubuntu;">
        <button class="btn btn-outline-secondary " type="button" *ngIf="searchText" (click)="clear()"
          [ngClass]="{'c-clear' : isFocus, 'c-clear-not-focus': !isFocus}">
          <mat-icon class="c-icon">close</mat-icon>
        </button>
      </div>
      <div class="table-responsive" matSort (matSortChange)="sortData($event)">
        <table class="table table-responsive table-borderless">
          <thead class="table-header">
            <tr>
              <td scope="col" class="col-lg-4 col-md-4" mat-sort-header="description">Name</td>
              <td scope="col" class="col-lg-4 col-md-4" mat-sort-header="userid">Location</td>
              <td scope="col" class="col-lg-4 col-md-4" mat-sort-header="defaulttype">Default Type</td>
              <td scope="col" class="d-flex justify-content-center">Actions</td>
            </tr>
          </thead>
          <tbody *ngIf="attQrListLoading">
            <tr>
              <td colspan="4" class="nodata">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="attQrListLoading == false">
            <tr *ngIf="attQrList.length == 0">
              <td colspan="3" class="nodata">Empty</td>
            </tr>
            <tr
              *ngFor="let item of (attQrList | filter:searchText:'attendanceQr') | paginate: { itemsPerPage: itemPerPage, currentPage: p }; let index = index">
              <td class="td-data td-edit" (click)="openSetupForm(item)">
                <span [title]="item.name">{{item.name}}</span>
              </td>
              <td class="td-data">
                <span [title]="item.locname">
                  {{item.locname}}
                </span>
              </td>

              <td class="td-data">
                <span
                  [title]="item.defaulttype == 'auto' ? 'Auto' : item.defaulttype == 'time' ? 'Time In/Out' : 'Check In'">
                  {{item.defaulttype == 'auto' ? 'Auto' : item.defaulttype == 'time' ? 'Time In/Out' : 'Check In'}}
                </span>
              </td>

              <td class="d-flex justify-content-center">


                <button class="btn btn-outline-info me-2" title="QR Code" (click)="goToQR(item)">
                  <i class="fa fa-qrcode"></i>
                </button>

                <button class="btn btn-outline-primary me-2" (click)="openSetupForm(item)" title="Edit">
                  <i class='fa fa-edit'></i>
                </button>

                <button class="btn btn-outline-danger" (click)="deleteAttQr(item.qrid, index)" title="Delete">
                  <i class="fa fa-trash-o"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination-controls class="paginate" (pageChange)="p = $event"
        *ngIf="(attQrList | filter:searchText:'attendanceQr').length > itemPerPage" previousLabel="Prev"
        nextLabel="Next">
      </pagination-controls>
    </ng-container>
  </div>
</div>